import { render, staticRenderFns } from "./RealEstateStatus.vue?vue&type=template&id=6152d2bf&scoped=true&"
import script from "./RealEstateStatus.vue?vue&type=script&lang=js&"
export * from "./RealEstateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152d2bf",
  null
  
)

export default component.exports